import React from 'react';
import { AwardIcon, CheckIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { productShortName, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="border-y border-electric/30 bg-panel py-16 sm:py-20" aria-labelledby="system-title" data-id="element-174" data-mp="3bhlk95796all">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-175" data-mp="36ja98r581u1s">
        <span className="inline-flex items-center gap-2 rounded-full border border-electric bg-electric/15 px-4 py-2 text-xs font-extrabold uppercase tracking-[.12em] text-white" data-id="element-176" data-mp="31l8v8kmnkkx6">
          <AwardIcon className="h-4 w-4 shrink-0 text-gold" aria-hidden="true" data-id="element-177" data-mp="2ssf1ji6glizs" /> The Most Comprehensive Electrical
          Engineering Teaching System
        </span>
        <SectionHeading id="system-title" className="mt-6" data-id="element-178" data-mp="2nv5c42j2l7by">
          {productShortName}
        </SectionHeading>
        <p className="mt-4 font-semibold text-ink" data-id="element-179" data-mp="2iw27gj70534i">
          {totalVolumes} volumes · {totalBonuses} exclusive bonuses · Everything you need to teach with confidence.
        </p>

        <p className="mx-auto mt-10 flex max-w-3xl items-start gap-3 rounded-2xl border border-electric/60 bg-navy p-6 text-left text-lg font-bold leading-relaxed text-white shadow-lg shadow-black/40" data-id="element-180" data-mp="13xwwviibpv31">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-gold" aria-hidden="true" data-id="element-181" data-mp="u2v3gah0m6un" />
          A complete system to enter the classroom prepared and deliver lessons that truly teach how electrical
          engineering works, why power systems matter, and how electrical technology contributes to safe, reliable energy
          systems.
        </p>
      </div>
    </section>;
}